// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c9cc1952] .ag-header{border-bottom:none !important}[data-v-c9cc1952] .ag-header-row{color:#6c757d !important;font-weight:400 !important;text-transform:uppercase !important;letter-spacing:.5px;margin-bottom:1rem !important}[data-v-c9cc1952] .ag-row.ag-row-last{border-bottom-style:none}", ""]);
// Exports
module.exports = exports;
